import { render } from "./CompProdutoRA.vue?vue&type=template&id=3480137f&scoped=true"
import script from "./CompProdutoRA.vue?vue&type=script&lang=js"
export * from "./CompProdutoRA.vue?vue&type=script&lang=js"

import "./CompProdutoRA.vue?vue&type=style&index=0&id=3480137f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3480137f"]])

export default __exports__